export default defineNuxtRouteMiddleware(() => {
  // skip middleware on server
  if (import.meta.server) return

  // only use on cab website
  const runtimeConfig = useRuntimeConfig()
  if (runtimeConfig.public.client !== 'cab') return

  try {
    window.utag?.view()
    return
  } catch (error) {
    return
  }
})
